import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid, Input, Typography } from '@material-ui/core';
import { UserServices } from '../../../Services/UserServices';
import AppLoader from '../../../Components/AppLoader';
import BulkUploadReport from '../../../Components/BulkUploadReport';
import useBulkUserUpload from '../../../hooks/useBulkUserUpload';
import { notify } from '../../../utils';

const userServices = new UserServices();

export default function UserBulkUpload({ open, handleClose, uuid, projectId, programmeType }) {

    const [isLoading, setIsLoading] = React.useState(false);
    const [templateProgrammeLabel, setTemplateProgrammeLabel] = React.useState('');
    const bulkUpload = useBulkUserUpload({
        customerId: uuid,
        onFinished: (result) => {
            const failed = result?.failed?.length || 0;
            if (result?.state === 'failed') notify('error', result.message || 'The upload did not finish.');
            else if (failed) notify('warning', `${failed} users failed. See the report.`);
            else notify('success', result?.message || 'Users uploaded.');
        },
    });
    const { reset: resetUpload } = bulkUpload;

    React.useEffect(() => {
        if (open) {
            resetUpload();
            setTemplateProgrammeLabel('');
        }
    }, [open, resetUpload]);

    const handleClickLink = async (evt) => {
        evt.preventDefault();
        setIsLoading(true);
        await userServices.getBulkTemplate(uuid, { projectId, programmeType }).then(
            data => {
                const templateUrl = data?.data?.url;
                if (!templateUrl) {
                    setIsLoading(false);
                    notify('error', 'Something went wrong');
                    return;
                }
                const link = document.createElement('a');
                const cacheBuster = /X-Amz-Signature|Signature=/.test(templateUrl) ? '' : `${templateUrl.includes('?') ? '&' : '?'}t=${Date.now()}`;
                link.href = `${templateUrl}${cacheBuster}`;
                link.setAttribute('download', 'bulkupload.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTemplateProgrammeLabel(data?.data?.programme_type_label || '');
                setIsLoading(false)
                notify('success', 'Sample Template downloaded successfully')
            },
            error => {
                setIsLoading(false)
                notify('error', 'Something went wrong')
                console.log('error.response.status', error);
            }
        );
    }

    const handleUploadTemplate = event => {
        event.preventDefault();
        const file = event.target.files && event.target.files[0];
        event.target.value = '';
        if (file) bulkUpload.upload(file);
    };

    const closeDialog = () => {
        bulkUpload.reset();
        handleClose();
    };

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{
                    style: { borderRadius: 15 }
                }}
                open={open}
                onClose={closeDialog}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="id" style={{ textAlign: "center" }}>
                    <h2>Bulk Upload User</h2>
                </DialogTitle>
                <DialogContent>
                    <Grid container style={{ paddingBottom: 25 }}>
                        {isLoading ? <AppLoader minHeight={160} /> : (
                            <>
                                <div style={{ padding: 10 }}>
                                    <button type="button" onClick={handleClickLink} style={{ padding: 0, border: 0, background: 'none', color: 'inherit', cursor: 'pointer', fontSize: 18, textDecoration: 'none' }}>
                                        <span>Click here for download Templete</span>
                                    </button>
                                </div>
                                {templateProgrammeLabel && (
                                    <Typography variant="body2" style={{ padding: '0 10px 10px' }}>
                                        Template for: {templateProgrammeLabel}
                                    </Typography>
                                )}
                                <div style={{ padding: 10 }}>
                                    <Input
                                        disableUnderline
                                        id="file-input"
                                        type="file"
                                        name="BulkTemplate"
                                        disabled={bulkUpload.uploading}
                                        inputProps={{ accept: '.xlsx,.xls' }}
                                        onChange={e => handleUploadTemplate(e)}
                                    />
                                </div>
                                <div style={{ padding: 10, width: '100%' }}>
                                    <BulkUploadReport job={bulkUpload.job} error={bulkUpload.error} onClose={closeDialog} />
                                </div>
                            </>
                        )}
                    </Grid>
                </DialogContent>
            </Dialog>
        </div >
    );
}
